Vendd.Scripts.load(function () {
    'use strict';

    if ($('.x-product-compare-list, .product-details-quick-view, .product-details-popup').length == 0) return;

    /* fixes popup iframe horizontal scrolling */
    $(".site-container").css("min-width", "initial");
    $(".site-container").css("min-width", "auto");
});